<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    :fullscreen="$vuetify.breakpoint.mobile"
    max-width="960"
    scrollable
  >
    <v-card light>
      <v-card-title class="ad-insights-dialog__title">
        <div>
          <div>Anzeigen-Insights – {{ domain }}</div>
          <div class="ad-insights-dialog__subtitle">
            {{ rangeText }}
            <span v-if="breakEvenRoas" class="ad-insights-dialog__breakeven">· Break-even-ROAS ≈ {{ number(breakEvenRoas) }}</span>
          </div>
        </div>
        <div class="d-flex align-center">
          <v-btn small text color="primary" to="/adInsights" @click="$emit('input', false)">
            <v-icon small left>mdi-arrow-expand-all</v-icon>
            Zur Seite
          </v-btn>
          <v-btn icon @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <AdInsightsPanel
          :active="value"
          :shop-code="shopCode"
          :break-even-roas="breakEvenRoas"
          :shop-revenue="shopRevenue"
          :shop-profit="shopProfit"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AdInsightsPanel from "@/components/Statistics/StatisticByShops/AdInsightsPanel";
import { mapGetters } from "vuex";
import { getDecimalNumberString } from "@/utils";
import dayjs from "dayjs";

export default {
  name: "AdInsightsDialog",
  components: { AdInsightsPanel },
  props: {
    value: Boolean,
    shopCode: String,
    domain: String,
    breakEvenRoas: {
      type: Number,
      default: null,
    },
    shopRevenue: {
      type: Number,
      default: null,
    },
    shopProfit: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["statisticRange"]),
    rangeText() {
      const format = (d) => dayjs(d).format("DD.MM.YYYY");
      const from = format(this.statisticRange.min);
      const to = format(this.statisticRange.max);
      return from === to ? from : `${from} – ${to}`;
    },
  },
  methods: {
    number(value, fraction = 2) {
      return getDecimalNumberString(value, fraction);
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-insights-dialog__title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.ad-insights-dialog__subtitle {
  font-size: 13px;
  font-weight: lighter;
  color: #757575;
}

.ad-insights-dialog__breakeven {
  font-weight: 600;
  color: #555555;
}
</style>
